import React, { Component } from "react";
export default class ImmediateRecall extends Component {
  render() {
    var {
      immediate_recall_check_1_points,
      immediate_recall_check_2_points,
      immediate_recall_check_3_points,
      immediate_recall_check_4_points,
      immediate_recall_check_5_points,
      immediate_recall_check_6_points,
      immediate_recall_check_7_points,
      immediate_recall_check_8_points,
      immediate_recall_check_9_points,
      immediate_recall_check_10_points,
      immediaterRecallNote,
    } = this.props.data;
    return (
      <>
        <ul style={{ paddingLeft: 20, fontSize: 19 }}>
          <li style={{ listStyle: "square" }}>
            Administration:
            <ul style={{ paddingLeft: 40 }}>
              <li style={{ listStyle: "circle" }}>
                Story should be read at a steady pace of 2 words per second/the
                story should take around 20 seconds to read out. When finished
                reading story aloud, say to participant “Now that’s the end of
                the story, what can you remember?” Time for recall is unlimited,
                until participants say that they can remember no more.
              </li>
            </ul>
          </li>
          <li style={{ listStyle: "square" }}>
            Scoring:
            <ul style={{ paddingLeft: 40 }}>
              <li style={{ listStyle: "circle" }}>
                Self-corrections are allowed; only the final answer is taken for
                scoring.
              </li>
              <li style={{ listStyle: "circle" }}>
                Score 1 point for each (either entire or part of) underlined
                section recalled. For example “annual litter collection”
                recalled as ‘annual collection’ ‘litter collection’ or ‘annual
                rubbish collection’ would each score 1 point. Similarly,
                ‘impressed and especially proud’ may be recalled as another
                positive emotional response to the event such as ‘pleased’.
                Number information must be recalled accurately, for example
                “Forty two people” recalled as ‘forty something’ would score 0
                points.
              </li>
              <li style={{ listStyle: "circle" }}>
                This immediate recall score will also be used later on to
                calculate the percentage of memory retained over time. No
                prompts should be given for specific information, only “is that
                everything you can remember” should be asked to confirm
                participant has finished recall.
              </li>
            </ul>
          </li>
          <li style={{ listStyle: "square" }}>
            Say:
            <ul style={{ paddingLeft: 40 }}>
              <li style={{ listStyle: "circle" }}>
                ‘‘I am going to read you a short story. Please listen carefully.
                When I am finished, say as much as you can remember’’
              </li>
              <li style={{ listStyle: "circle" }}>
                <p className="fs-19 pb-3">
                  <i>
                    Last{" "}
                    <u>
                      <b>Sunday</b>
                    </u>
                    , the{" "}
                    <u>
                      <b>Annual Park Cleanup</b>
                    </u>{" "}
                    took place in{" "}
                    <u>
                      <b>Marigold Woods</b>
                    </u>
                    .{" "}
                    <u>
                      <b>Forty two</b>
                    </u>{" "}
                    people joined in to remove old{" "}
                    <u>
                      <b>bicycles and shopping carts</b>
                    </u>
                    . Mr{" "}
                    <u>
                      <b>Robert Webber</b>
                    </u>{" "}
                    from the{" "}
                    <u>
                      <b>woodland project</b>
                    </u>{" "}
                    told local reporters that he was very{" "}
                    <u>
                      <b>impressed and especially proud</b>
                    </u>{" "}
                    of the{" "}
                    <u>
                      <b>17 children</b>
                    </u>{" "}
                    who came along
                  </i>
                </p>
              </li>
              <li style={{ listStyle: "circle" }}>
                “Now that’s the end of the story, what can you remember?”
              </li>
            </ul>
          </li>
          <li style={{ listStyle: "square" }}>
            Answers:
            <table cellpadding="11" className="answer-table">
              <tr>
                <th>Question</th>
                <th>1 Point</th>
              </tr>
              <tr>
                <td>Sunday</td>
                <td style={{ width: 85 }}>
                  <input
                    type="checkbox"
                    name="immediate_recall_check_1_points"
                    value={immediate_recall_check_1_points}
                    checked={
                      immediate_recall_check_1_points == 1 ? true : false
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Annual Park Cleanup</td>
                <td style={{ width: 85 }}>
                  <input
                    type="checkbox"
                    name="immediate_recall_check_2_points"
                    value={immediate_recall_check_2_points}
                    checked={
                      immediate_recall_check_2_points == 1 ? true : false
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Marigold Woods</td>
                <td style={{ width: 85 }}>
                  <input
                    type="checkbox"
                    name="immediate_recall_check_3_points"
                    value={immediate_recall_check_3_points}
                    checked={
                      immediate_recall_check_3_points == 1 ? true : false
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Forty two </td>
                <td style={{ width: 85 }}>
                  <input
                    type="checkbox"
                    name="immediate_recall_check_4_points"
                    value={immediate_recall_check_4_points}
                    checked={
                      immediate_recall_check_4_points == 1 ? true : false
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Bicycles and shopping carts</td>
                <td style={{ width: 85 }}>
                  <input
                    type="checkbox"
                    name="immediate_recall_check_5_points"
                    value={immediate_recall_check_5_points}
                    checked={
                      immediate_recall_check_5_points == 1 ? true : false
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Robert Webber</td>
                <td style={{ width: 85 }}>
                  <input
                    type="checkbox"
                    name="immediate_recall_check_6_points"
                    value={immediate_recall_check_6_points}
                    checked={
                      immediate_recall_check_6_points == 1 ? true : false
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Woodland project</td>
                <td style={{ width: 85 }}>
                  <input
                    type="checkbox"
                    name="immediate_recall_check_7_points"
                    value={immediate_recall_check_7_points}
                    checked={
                      immediate_recall_check_7_points == 1 ? true : false
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Very impressed and especially proud</td>
                <td style={{ width: 85 }}>
                  <input
                    type="checkbox"
                    name="immediate_recall_check_8_points"
                    value={immediate_recall_check_8_points}
                    checked={
                      immediate_recall_check_8_points == 1 ? true : false
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>17</td>
                <td style={{ width: 85 }}>
                  <input
                    type="checkbox"
                    name="immediate_recall_check_9_points"
                    value={immediate_recall_check_9_points}
                    checked={
                      immediate_recall_check_9_points == 1 ? true : false
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>children</td>
                <td style={{ width: 85 }}>
                  <input
                    type="checkbox"
                    name="immediate_recall_check_10_points"
                    value={immediate_recall_check_10_points}
                    checked={
                      immediate_recall_check_10_points == 1 ? true : false
                    }
                  />
                </td>
              </tr>
            </table>
            <br />
          </li>
        </ul>
        <div style={{ maxWidth: 500, marginTop: 24 }}>
          <label className="margin-left">Note:</label>
          <textarea
            name="immediaterRecallNote"
            value={immediaterRecallNote}
            className="ecas-textarea-field margin-left"
            rows={6}
            cols={10}
          />
        </div>
      </>
    );
  }
}
